import { render, staticRenderFns } from "./OrderPayersList.vue?vue&type=template&id=a66b3918&scoped=true"
import script from "./OrderPayersList.vue?vue&type=script&lang=js"
export * from "./OrderPayersList.vue?vue&type=script&lang=js"
import style0 from "./OrderPayersList.vue?vue&type=style&index=0&id=a66b3918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66b3918",
  null
  
)

export default component.exports